import { getNormalizedPathFromSlugOrPathNames } from '@unifyapps/carbon/no-code/utils/path/interfacePathNormalize';
import { INTERFACE_BASE_ROUTE } from '../../../no-code/utils/route';

/**
 * The URL configured in a URL NavItem can have 2 structures:
 * 1. With domain (https://…, //host, mailto:): no need to adapt URL, return undefined — used as-is.
 * 2. Without domain (e.g. "/page-3"): internal page path, needs adapting. In builder/preview, add
 *    the interface prefix → /interfaces/<id>/preview/page-3; in runner it stays "/page-3".
 *    Returns the normalized path + any ?query/#hash suffix so the caller can build that route.
 *    (Also returns undefined for already-routed /interfaces/… and empty urls — left as-is.)
 */
export function getInterfacePagePathFromUrl(
  rawUrl: string,
): { path: string; suffix: string } | undefined {
  let parsed: URL;
  try {
    // fake origin (SSR-safe, same trick as addSearchParamsInRoute) so relative urls resolve and a
    // different origin flags an external link.
    parsed = new URL(rawUrl, 'http://localhost');
  } catch {
    return undefined;
  }

  const path = getNormalizedPathFromSlugOrPathNames(parsed.pathname);

  if (
    parsed.origin !== 'http://localhost' || // external / protocol-relative / scheme url
    parsed.pathname.startsWith(INTERFACE_BASE_ROUTE) || // already routed — don't double-adapt
    !path // root / empty url
  ) {
    return undefined;
  }

  return { path, suffix: `${parsed.search}${parsed.hash}` };
}
